import {
  IMPORT_STUDENTS_SUCCESS,
  IMPORT_STUDENTS_ASYNC_START,
  IMPORT_STUDENTS_ASYNC_END
} from "../actions/actions";

export default function importStudents(state = {}, action) {
  switch (action.type) {
    case IMPORT_STUDENTS_SUCCESS:
      return {
        ...state,
        students: action.students,
        successful: action.successful
      };

    case IMPORT_STUDENTS_ASYNC_START:
      return { ...state, aSyncCall: true };

    case IMPORT_STUDENTS_ASYNC_END:
      return { ...state, aSyncCall: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/importStudents.js